module.exports = __webpack_public_path__ + "img/avatar_sel.92deaaf3.png";